import tools from 'tools';

export default class ProductListItemCollection {
    constructor() {
        this.itemClass = 'product-list-item';
        this.itemSelector = '.' + this.itemClass;

        // Event is here, because it must not reinitialize
        $(document).on('custom:ProductListItemCollection.reinit', this.init.bind(this));
        this.init();
    }

    /**
     * Can be triggered by external event
     */
    init() {
        this.applyLayoutModifications();
        this.bindEvents();
        this.checkBasketStatus();
    }

    /**
     * Modifications because of weird seo requirements
     */
    applyLayoutModifications() {
    }

    bindEvents() {
        $('.product-list-item__buy-button').off('click.collection').on('click.collection', this.onBuyButtonClick.bind(this));
        //$('.product-list-item__fast-order-button').off('click.collection').on('click.collection', this.onFastOrderButtonClick.bind(this));
        //$('.product-list-item__quick-view').off('click.collection').on('click.collection', this.onQuickViewClick.bind(this));
    }

    checkBasketStatus() {
        if (!(typeof app == 'object' && Array.isArray(app.basketProductIds))) {
            return;
        }

        app.basketProductIds.forEach((id) => {
            this.markAsInBasket(id);
        });
    }

    getItemNodeFromEvent(e) {
        return $(e.currentTarget).closest(this.itemSelector);
    }

    getItemNodeById(id) {
        return $(this.itemSelector + '[data-id="' + id + '"]');
    }

    markAsInBasket(id, withTransition = false) {
        const $el = this.getItemNodeById(id);

        if ($el.length === 0) {
            return;
        }

        // Keep visualization even if the item is already in basket
        /*if ($el.hasClass(this.itemClass + '--in-basket')) {
            return;
        }*/

        $el.addClass(this.itemClass + '--in-basket');

        const $button = $el.find(this.itemSelector + '__buy-button');
        $button.addClass('product-buy-button--in-basket');
        $button.find('.product-buy-button__label').text('В корзине');

        if (withTransition) {
            $button.addClass('product-buy-button--transition');

            setTimeout(() => {
                $button.removeClass('product-buy-button--transition');
            }, 1000);
        }
    }

    onBuyButtonClick(e) {
        e.preventDefault();

        const $el = this.getItemNodeFromEvent(e);
        const productId = $el.attr('data-id');
        let quantity = $el.find('[name="quantity"]').val();

        if (isNaN(quantity) || quantity < 1) {
            quantity = 1;
        }

        BX.ajax.runComponentAction('nav:ajax.basket', 'add', {
            mode:'ajax',
            data: {
                id: productId,
                quantity,
            }
        }).then((response) => {
            $(document).trigger($.Event('custom:basketUpdate', response.data));
            this.markAsInBasket(productId, true);
        }).catch((response) => {
            alert(response.errors.map(item => item.message).join("\n"));
        });
    }
}
